// KPI funnel popup on-site: eventi onsite_recovery_events + leggenda merchant.
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LegendInfoIcon, useMediaMinWidth } from "../shared";

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children Prima colonna della griglia a 4 (es. card KPI attribuzione popup).
 * @param {{ shown: number; emitted: number; redeemed: number; emit_rate_pct: number|null; redeem_rate_pct: number|null }|undefined} props.events
 */
export default function StatsPopupFunnel({ events, children }) {
  const { t } = useTranslation("stats");
  const isDesktop = useMediaMinWidth(900);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!isDesktop) setMobileOpen(false);
  }, [isDesktop]);

  const panelId = "stats-popup-events-help-panel";
  const showPanel = isDesktop || mobileOpen;

  const e = events || {};
  const shown = Number(e.shown) || 0;
  const emitted = Number(e.emitted) || 0;
  const redeemed = Number(e.redeemed) || 0;
  const emitRate = e.emit_rate_pct;
  const redeemRate = e.redeem_rate_pct;

  return (
    <div className="ch-card" style={{ marginBottom: 20 }}>
      <section
        className="ch-help-legend ch-help-legend--embed"
        aria-label={t("popupFunnel.legendAria")}
        style={{ marginBottom: 18 }}
      >
        <div className="ch-help-legend__accent" aria-hidden="true" />
        {!isDesktop && (
          <button
            type="button"
            className="ch-help-legend__summary"
            aria-expanded={mobileOpen}
            aria-controls={panelId}
            onClick={() => setMobileOpen((o) => !o)}
          >
            <span className="ch-help-legend__sum-icon">
              <LegendInfoIcon size={18} />
            </span>
            <span>
              {t("popupFunnel.legendSummaryTitle")}
              <span className="ch-help-legend__sum-hint">{t("popupFunnel.legendSummaryHint")}</span>
            </span>
            <span className="ch-help-legend__chev" aria-hidden="true" />
          </button>
        )}
        {showPanel && (
          <div id={panelId} className="ch-help-legend__panel">
            {!isDesktop && (
              <header className="ch-help-legend__head ch-help-legend__head--mobile-only">
                <div className="ch-help-legend__head-icon" aria-hidden="true">
                  <LegendInfoIcon />
                </div>
                <div>
                  <h3 className="ch-help-legend__title">{t("popupFunnel.legendTitle")}</h3>
                  <p className="ch-help-legend__sub">{t("popupFunnel.legendSubMobile")}</p>
                </div>
              </header>
            )}

            <div className="ch-help-legend__desktop">
              <div className="ch-help-legend__desktop-intro">
                <div className="ch-help-legend__head-icon" aria-hidden="true">
                  <LegendInfoIcon size={20} />
                </div>
                <div>
                  <h3 className="ch-help-legend__title">{t("popupFunnel.legendTitle")}</h3>
                  <p className="ch-help-legend__sub">{t("popupFunnel.legendSubDesktop")}</p>
                </div>
              </div>

              <div className="ch-help-legend__grid ch-help-legend__grid--3">
                <div className="ch-help-legend__cell">
                  <div className="ch-help-legend__cell-rail ch-help-legend__cell-rail--neutral" aria-hidden="true" />
                  <span className="ch-status neutral">
                    <span className="status-dot" />
                    {t("popupFunnel.helpShownLabel")}
                  </span>
                  <p className="ch-help-legend__cell-text">{t("popupFunnel.helpShownBody")}</p>
                </div>
                <div className="ch-help-legend__cell">
                  <div className="ch-help-legend__cell-rail ch-help-legend__cell-rail--warning" aria-hidden="true" />
                  <span className="ch-status warning">
                    <span className="status-dot" />
                    {t("popupFunnel.helpEmittedLabel")}
                  </span>
                  <p className="ch-help-legend__cell-text">{t("popupFunnel.helpEmittedBody")}</p>
                </div>
                <div className="ch-help-legend__cell">
                  <div className="ch-help-legend__cell-rail ch-help-legend__cell-rail--success" aria-hidden="true" />
                  <span className="ch-status success">
                    <span className="status-dot" />
                    {t("popupFunnel.helpRedeemedLabel")}
                  </span>
                  <p className="ch-help-legend__cell-text">{t("popupFunnel.helpRedeemedBody")}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      <h2 style={{ marginTop: 0 }}>{t("popupFunnel.title")}</h2>
      <p>{t("popupFunnel.subtitle")}</p>

      <div className="ch-popup-metrics-row">
        {children}
        <div className="ch-popup-metric-cell">
          <div className="stat-label" style={{ marginBottom: 4 }}>
            {t("popupFunnel.metricShown")}
          </div>
          <div className="ch-popup-metric-val">{shown}</div>
        </div>
        <div className="ch-popup-metric-cell">
          <div className="stat-label" style={{ marginBottom: 4 }}>
            {t("popupFunnel.metricEmitted")}
          </div>
          <div className="ch-popup-metric-val">{emitted}</div>
          <div className="ch-popup-metric-meta">{emitRate != null ? t("popupFunnel.rateVsShown", { pct: emitRate }) : "—"}</div>
        </div>
        <div className="ch-popup-metric-cell">
          <div className="stat-label" style={{ marginBottom: 4 }}>
            {t("popupFunnel.metricRedeemed")}
          </div>
          <div className="ch-popup-metric-val">{redeemed}</div>
          <div className="ch-popup-metric-meta">{redeemRate != null ? t("popupFunnel.rateVsEmitted", { pct: redeemRate }) : "—"}</div>
        </div>
      </div>

      <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 0", lineHeight: 1.55 }}>
        {t("popupFunnel.ordersNote")}
      </p>
    </div>
  );
}
